<template>
  <v-dialog persistent v-model="dialog" max-width="550">
    <template v-slot:activator="{ on }">
      <v-btn
        v-on="on"
        x-small
        color="primary"
        :outline="type == 'transfer'"
        :depressed="type == 'paypal'"
      >
        <div>{{type=='transfer'?$t('Premium Transfer'):'PayPal'}}</div>
      </v-btn>
    </template>
    <v-card v-show="dialog">
      <div class="text-xs-right">
        <v-spacer></v-spacer>
        <v-btn flat icon small fab @click="onClose">
          <v-icon>close</v-icon>
        </v-btn>
      </div>
      <v-card-title style="padding-bottom: 0;padding-top: 0">
        <h5 style="margin-top: 0">{{$t('Registering or Extending Premium Package')}}</h5>
      </v-card-title>
      <div v-show="!loading">
        <v-card-text style="padding-top: 10px">
          <v-layout wrap row>
            <v-flex xs12 sm6 class="form-control pa-1" :class="{'has-error': errors.has('phone')}">
              <label>{{$t('Phone')}}</label>
              <input
                :data-vv-as="$t('Phone')"
                v-validate="'required'"
                v-model="input.phoneno"
                class="form-control"
                type="text"
                name="phone"
              />
              <span class="text-error" v-if="errors.has('phone')">{{ errors.first('phone') }}</span>
            </v-flex>
            <v-flex xs3 sm3 class="form-control pa-1" :class="{'has-error': errors.has('age')}">
              <label>{{$t('Age')}}</label>
              <input
                :data-vv-as="$t('Age')"
                v-validate="'required'"
                name="age"
                v-model.number="input.age"
                class="form-control"
                type="number"
              />
              <span class="text-error" v-if="errors.has('age')">{{ errors.first('age') }}</span>
            </v-flex>
            <v-flex
              xs9
              sm6
              class="form-control pa-1"
              :class="{'has-error': errors.has('province')}"
            >
              <label>{{$t('Province')}}</label>
              <input
                :data-vv-as="$t('Province')"
                v-validate="'required'"
                name="province"
                v-model="input.province"
                class="form-control"
                type="text"
              />
              <span class="text-error" v-if="errors.has('province')">{{ errors.first('province') }}</span>
            </v-flex>
            <v-flex xs12 sm6 class="form-control pa-1" :class="{'has-error': errors.has('email')}">
              <label>{{$t('Email')}}</label>
              <input
                :data-vv-as="$t('Email')"
                v-validate="'required|email'"
                name="email"
                v-model="input.email"
                class="form-control"
                type="text"
              />
              <span class="text-error" v-if="errors.has('email')">{{ errors.first('email') }}</span>
            </v-flex>
            <v-flex
              xs12
              sm6
              class="form-control pa-1"
              :class="{'has-error': errors.has('business_type')}"
            >
              <label>{{$t('Business Type')}}</label>
              <multiselect
                :data-vv-as="$t('Business Type')"
                v-validate="'required'"
                name="business_type"
                v-model="input.business_type"
                :options="options.businesstype"
                :searchable="true"
                :close-on-select="true"
                :show-labels="false"
                :placeholder="$t('Business Type')"
              >
                <template slot="singleLabel" slot-scope="props">{{$t(props.option)}}</template>
                <template slot="option" slot-scope="props">{{$t(props.option)}}</template>
              </multiselect>
              <span
                class="text-error"
                v-if="errors.has('business_type')"
              >{{ errors.first('business_type') }}</span>
            </v-flex>
            <v-flex
              xs12
              sm5
              class="form-control pa-1"
              :class="{'has-error': errors.has('suggest')}"
            >
              <label>{{$t('How did you hear about us?')}}</label>
              <multiselect
                ref="suggest"
                :data-vv-as="$t('How did you hear about us?')"
                v-validate="'required'"
                name="suggest"
                v-model="input.suggest"
                :options="options.suggest"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
              ></multiselect>
              <span class="text-error" v-if="errors.has('suggest')">{{ errors.first('suggest') }}</span>
            </v-flex>
            <v-flex
              v-if="input.suggest == 'Other'"
              xs12
              sm12
              class="form-control pa-1"
              :class="{'has-error': errors.has('suggest_other')}"
            >
              <label>{{$t('Please identify(if available)')}}</label>
              <input
                :data-vv-as="$t('Other')"
                v-validate="'required_if:suggest,Other'"
                name="suggest_other"
                v-model="input.suggest_other"
                class="form-control"
                type="text"
              />
              <span
                class="text-error"
                v-if="errors.has('suggest_other')"
              >{{ errors.first('suggest_other') }}</span>
            </v-flex>
            <v-flex
              xs12
              sm12
              class="form-control pa-1"
              :class="{'has-error': errors.has('contact')}"
            >
              <label>{{$t('Please leave your line ID in order to contact you back')}}</label>
              <autoresize-textarea
                :data-vv-as="$t('Contact')"
                name="contact"
                v-validate="{'required': ['btn_12month_extra_fb', '12233'].includes(params)}"
                v-model="input.contact"
              />
              <span class="text-error" v-if="errors.has('contact')">{{ errors.first('contact') }}</span>
            </v-flex>
            <v-flex
              xs12
              sm12
              class="form-control pa-1"
              :class="{'has-error': errors.has('Reason to Buy')}"
            >
              <label>{{$t(`Which of Zwiz's features helps you to make a purchase`)}}</label>
              <multiselect
                :data-vv-as="$t(`Reason to Buy`)"
                v-validate="'required'"
                name="Reason to Buy"
                v-model="input.reason_to_buy"
                :options="options.reason_to_buy"
                :searchable="false"
                :close-on-select="true"
                :show-labels="false"
              >
                <template slot="singleLabel" slot-scope="props">{{$t(props.option)}}</template>
                <template slot="option" slot-scope="props">{{$t(props.option)}}</template>
              </multiselect>
              <!-- <autoresize-textarea
                :data-vv-as="$t(`Reason to Buy`)"
                v-validate="'required'"
                name="Reason to Buy"
                v-model="input.reason_to_buy"
              />-->
              <span
                class="text-error"
                v-if="errors.has('Reason to Buy')"
              >{{ errors.first('Reason to Buy') }}</span>
            </v-flex>

            <v-flex v-if="type == 'transfer'" xs12 class="text-xs-center">
              <v-btn @click="close" class="mx-0" color="grey" outline>{{$t('cancel')}}</v-btn>
              <v-btn
                @click="saveData('transfer')"
                class="mx-0"
                depressed
                color="primary"
              >{{$t('Proceed')}}</v-btn>
            </v-flex>

            <v-flex v-show="type == 'paypal'" xs12 class="text-xs-center">
              <div :ref="params" :id="params" style="margin-top: 15px;"></div>
            </v-flex>
          </v-layout>
        </v-card-text>
      </div>
      <template v-if="loading">
        <div style="height: 420px;">
          <v-container fill-height grid-list-md text-xs-center>
            <v-layout row wrap align-center>
              <v-flex>
                <scale-loader
                  :loading="loading"
                  :color="$vuetify.theme.primary"
                  height="45px"
                  width="7px"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </div>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import api from '@/api'
import Multiselect from 'vue-multiselect'
import AutoresizeTextarea from '@/components/elements/AutoresizeTextarea.vue'
import ScaleLoader from 'vue-spinner/src/ScaleLoader.vue'
import { mapGetters } from 'vuex'

export default {
  props: ['params', 'type', 'pack', 'pid'],
  data() {
    return {
      dialog: false,
      loading: true,
      paypal_actions: undefined,
      input: {
        age: null,
        phoneno: '',
        province: '',
        email: '',
        business_type: '',
        suggest: '',
        reason_to_buy: '',
        suggest_other: '',
        locale: '',
        source: 'CMS',
        contact: ''
      },
      input_cache: '',
      options: {
        reason_to_buy: [
          'Real-time Response',
          'Line chatbot',
          'status & Tag',
          'Broadcast (Customize)',
          'Shop service (unlimited)',
          'Import previous users',
          'AI Training',
          'Line notification',
          'Reply to a comment (selected posts)',
          'Creating more than 10 sets of Q&A in Reply Comment',
          'Creating more than 10 sets of Q&A in Chabot Conversation'
        ],
        businesstype: [
          'Accessory',
          'Application & Platform',
          'Automotive',
          'Agriculture',
          'Accommodation',
          'Beauty',
          'Blogger',
          'Construction',
          'Dental Clinic',
          'Education',
          'Electronics',
          'Event',
          'Fashion',
          'Finance & Investment',
          'Food & Beverage',
          'Gadget & IT',
          'Game',
          'Gold',
          'Health',
          'Insurance',
          'Lifestyle',
          'Logistics',
          'Media & Entertainment',
          'Medication',
          'Mom and Kids',
          'Online Marketing',
          'Property',
          'Packaging',
          'Restaurant',
          'Travel',
          'Others'
        ],
        suggest: ['Facebook', 'Google', 'Other']
      }
    }
  },
  components: {
    Multiselect,
    AutoresizeTextarea,
    ScaleLoader
  },
  mounted() {
    let vm = this
    this.input_cache = JSON.stringify(this.input)
    if (this.type == 'paypal') {
      vm.$nextTick(function() {
        let itemname = vm.params.split('_')
        vm.renderPaypalBtn(
          `#${vm.params}`,
          itemname[1] + '_' + itemname[2] + (itemname[3] ? '_' + itemname[3] : '')
        )
      })
    }
  },
  computed: {
    formErrors() {
      return this.errors.items
    },
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      currentLang: 'currentLang'
    })
  },
  methods: {
    onClose() {
      this.dialog = false
    },
    renderPaypalBtn: function(btn_name, itemname) {
      var SERVER = 'https://zwizai.herokuapp.com'
      var vm = this
      // console.log(btn_name,$(btn_name),vm.$refs[btn_name])
      // console.log(vm.$refs[btn_name])
      // var locale = this.currentLang == 'th' ? 'th_TH' : 'en_US'
      var locale = this.currentLang == 'th' ? 'th_TH' : 'gb' ? 'en_US' : 'la_LA'
      if ($(btn_name).get(0)) {
        paypal.Button.render(
          {
            locale: locale,
            env: vm.environment, // Or 'production'
            // Set up the payment:
            // 1. Add a payment callback
            payment: function(data, actions) {
              // 2. Make a request to your server
              return actions.request
                .post(SERVER + '/my-api/create-payment/', {
                  itemname: itemname,
                  pageid: vm.selectedBot.pageid
                })
                .then(function(res) {
                  // 3. Return res.id from the response
                  return res.id
                })
            },
            // Execute the payment:
            // 1. Add an onAuthorize callback
            onAuthorize: function(data, actions) {
              // 2. Make a request to your server
              return actions.request
                .post(SERVER + '/my-api/execute-payment/', {
                  paymentID: data.paymentID,
                  payerID: data.payerID,
                  itemname: itemname,
                  pageid: vm.selectedBot.pageid
                })
                .then(function(res) {
                  // 3. Show the buyer a confirmation message.
                  // alert("payment completed");

                  // console.log(res)
                  vm.$store.dispatch('loading')
                  if (res.status == 'success') {
                    if (vm.selectedBot) {
                      vm.$store.dispatch('updateBotDetail').then(
                        function() {
                          vm.$store.dispatch('loading')
                          vm.$swal
                            .fire({
                              title: vm.$t('Payment successful'),
                              type: 'success',
                              confirmButtonText: vm.$t('Confirm'),
                              cancelButtonText: vm.$t('cancel'),
                              reverseButtons: true,
                              footer: vm.$t(
                                'If you want any help, please contact via E-mail: sales@zwiz.ai'
                              )
                            })
                            .then(result => {
                              vm.$swal.fire({
                                title: vm.$t('Please wait,we will get back to you shortly'),
                                type: 'info',
                                confirmButtonText: vm.$t('Confirm'),
                                showCancelButton: false,
                                reverseButtons: true,
                                footer: vm.$t(
                                  'If you want any help, please contact via E-mail: sales@zwiz.ai'
                                )
                              })
                            })
                        },
                        function(error) {
                          vm.$store.dispatch('loading')
                          vm.errorMessage = vm.$t(
                            'Cannot update a chatbot. please contact us via Email:'
                          )
                          vm.$swal.fire({
                            title: vm.$t('Payment Unsuccessful'),
                            text: vm.errorMessage,
                            type: 'error',
                            confirmButtonText: vm.$t('Confirm'),
                            cancelButtonText: vm.$t('cancel'),
                            reverseButtons: true,
                            footer: vm.$t(
                              'If you want any help, please contact via E-mail: sales@zwiz.ai'
                            )
                          })
                        }
                      )
                    }
                    // vm.saveData('paypal')
                    // vm.close()
                  } else {
                    vm.errorMessage = res.status
                    vm.$swal.fire({
                      title: vm.$t('Payment Unsuccessful'),
                      text: vm.errorMessage,
                      type: 'error',
                      confirmButtonText: vm.$t('Confirm'),
                      cancelButtonText: vm.$t('cancel'),
                      reverseButtons: true,
                      footer: vm.$t(
                        'If you want any help, please contact via E-mail: sales@zwiz.ai'
                      )
                    })
                    // vm.saveData('paypal')
                    // vm.close()
                  }
                })
            },
            validate: function(actions) {
              vm.paypal_actions = actions
              vm.paypal_actions.disable()
            },
            onClick: function(data, actions) {
              if (vm.paypal_actions) {
                vm.$validator.validate().then(result => {
                  if (!result) {
                    // do stuff if not valid.
                    vm.paypal_actions.disable()
                    return false
                  }
                  vm.saveData('paypal')
                  vm.paypal_actions.enable()
                })
              }
            }
          },
          btn_name
        )
      }
    },
    close() {
      this.input = JSON.parse(this.input_cache)
      this.dialog = false
    },
    saveData() {
      let vm = this
      let openMsg
      var options = [
        [{ pid: 8521, qty: 1, option: '3 MONTHS' }],
        [{ pid: 8520, qty: 1, option: '6 MONTHS' }],
        [{ pid: 8519, qty: 1, option: '1 YEAR' }],
        [{ pid: 12233, qty: 1, option: '1 YEAR + SERVICE' }]
      ]
      openMsg = () => {
        window.location.assign(
          `https://m.me/361231620965547?ref=tempcart_${JSON.stringify(
            options.find(el => el[0].pid == vm.pid)
          )}`
        )
      }

      vm.$validator.validateAll().then(result => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        vm.loading = true

        vm.input.locale = vm.$store.state.currentLang
        vm.input.type = vm.type
        vm.input.facebook_name = vm.$store.state.facebook_name
        vm.input.pagename = vm.selectedBot.pagename
        let data = {
          pageid: vm.$store.state.selectedBot.pageid,
          obj: vm.input,
          package: vm.pack
        }
        api.postInfocustomerspremium(data, (error, response) => {
          if (error) console.error(error)
          vm.loading = false
          if (vm.type == 'transfer') {
            vm.close()
            openMsg()
          }
        })
      })
    }
  },
  watch: {
    input: {
      deep: true,
      handler() {
        let vm = this
        if (vm.type == 'paypal') {
          vm.$validator.validate().then(result => {
            if (!result) {
              // do stuff if not valid.
              vm.paypal_actions.disable()
              vm.errors.clear()
              return false
            }
            vm.paypal_actions.enable()
          })
        }
      }
    },
    dialog() {
      let vm = this
      if (vm.dialog == true) {
        let data = { pageid: vm.$store.state.selectedBot.pageid, type: vm.type, package: vm.pack }
        vm.loading = true

        api.getInfocustomerspremium(data, (error, response) => {
          if (error) console.error(error)

          if (response.data.length) {
            Object.assign(vm.input, response.data[0])
          }
          vm.errors.clear()
          vm.loading = false
        })
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/elements/premiumForm.vue